const state = () => ({
  // IPのID
  ipId: 0,
  // ストーリー話数表示名
  label: '',
  // ストーリータイトル名
  title: '',
  // ストーリーデータ配列
  csvData: [],
  // 再生中インデックス番号
  currentIndex: -1,
  // 再生ロック中フラグ
  isPlayLock: true,
  // ストーリー終了済フラグ
  isEnded: false,
  // UI非表示フラグ
  isHideUI: false,
  // AUTOモード中フラグ
  isAuto: false,
});

const getters = {

};

const actions = {
  reset({ commit }) {
    commit('reset');
  },
  setIpId({ commit }, value) {
    commit('setIpId', value);
  },
  setTitle({ commit }, value) {
    commit('setTitle', value);
  },
  setCsvData({ commit }, value) {
    commit('setCsvData', value);
  },
  setIndex({ commit }, value) {
    commit('setIndex', value);
  },
  setPlayLock({ commit }, value) {
    commit('setPlayLock', value);
  },
  setEnded({ commit }, value) {
    commit('setEnded', value);
  },
  setHideUI({ commit }, value) {
    commit('setHideUI', value);
  },
  setAuto({ commit }, value) {
    commit('setAuto', value);
  }
};

const mutations = {
  reset(state) {
    state.ipId = 0;
    state.label = '';
    state.title = '';
    state.csvData = [];
    state.currentIndex = -1;
    state.isPlayLock = true;
    state.isEnded = false;
    state.isHideUI = false;
    state.isAuto = false;
  },
  setIpId(state, value) {
    state.ipId = value;
  },
  setTitle(state, value) {
    state.label = value.label;
    state.title = value.title;
  },
  setCsvData(state, value) {
    state.csvData = value;
  },
  setIndex(state, value) {
    state.currentIndex = value;
  },
  setPlayLock(state, value) {
    state.isPlayLock = value;
  },
  setEnded(state, value) {
    state.isEnded = value;
  },
  setHideUI(state, value) {
    state.isHideUI = value;
  },
  setAuto(state, value) {
    state.isAuto = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
